import blueCheckImage from "assets/img/blue_check.png?url";

export const LOAD_COMPLETE_FAVICON = blueCheckImage;
